import { Component, OnInit, Input } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ShareDataService } from 'src/app/_services/ShareData.service';
import { AdminServiceService } from 'src/app/_services/AdminService.service';
import { AlertifyService } from 'src/app/_services/alertify.service';
import { ActionType } from 'src/app/_models/ActionType.enum';
import { DataSource } from 'src/app/_models/DataSource';
import { ViewSource } from 'src/app/_models/ViewSource';


@Component({
  selector: 'app-emailconfiguration',
  templateUrl: './emailconfiguration.component.html',
  styleUrls: ['./emailconfiguration.component.css']
})
export class EmailconfigurationComponent implements OnInit {

  @Input() currentApiKey: any;
  emailConfigs: any;
  isLoading = false;
  selectedClientConfig: any;
  clientConfigJson = '';
  
  constructor(private _shareData: ShareDataService, private _adminService: AdminServiceService, private _alertify: AlertifyService) { }

  ngOnInit() {

    this._shareData.currentDataSource.subscribe(data => {
      if (data) {
        this.updateRowData(data);
      }
    });

    if (this.currentApiKey) {
      this.isLoading = true;
      this._adminService.getEmailConfigurations(this.currentApiKey).subscribe(data => {
        this.emailConfigs = data;
        this.isLoading = false;
      }, error => {
        if (error !== 'Not Found') {
          this._alertify.error(error);
        }
      });  
    }
  }

  onAddNewEmail() {
    this._shareData.notifyCurrentApiKey(this.currentApiKey);
    this.notifyAction(null, ActionType.Add, "emailconfiguration", null);
  }

  onEditEmailConfig(emailConfig) {
    this._shareData.notifyCurrentApiKey(this.currentApiKey);
    this.notifyAction(emailConfig.id, ActionType.Edit, "emailconfiguration", emailConfig);
  }

  onShowTemplates(emailConfig) {
    this.notifyAction(this.currentApiKey, ActionType.Edit, "emailtemplates", emailConfig);
    this._shareData.notifyCurrentView( new ViewSource(this.currentApiKey, 'emailtemplates'));
  }

  onClientConfig(emailConfig) {
    this.selectedClientConfig = emailConfig;
    this.clientConfigJson = 'Loading...';
    this._adminService.getEmailTemplates(this.currentApiKey, emailConfig.id).subscribe((templates: any[]) => {
      if (!templates || templates.length === 0) {
        this.clientConfigJson = JSON.stringify({ apiKey: this.currentApiKey, configEmail: emailConfig.fromEmail, templates: [] }, null, 2);
        return;
      }
      const fieldRequests = templates.map(t =>
        this._adminService.getEmailTemplateFields(this.currentApiKey, emailConfig.id, t.id)
      );
      forkJoin(fieldRequests).subscribe((fieldsResults: any[]) => {
        const obj = {
          apiKey: this.currentApiKey,
          configEmail: emailConfig.fromEmail,
          templates: templates.map((t, i) => ({
            id: t.id,
            code: t.code,
            fields: Array.isArray(fieldsResults[i]) ? fieldsResults[i] : []
          }))
        };
        this.clientConfigJson = JSON.stringify(obj, null, 2);
      }, error => {
        this._alertify.error(error);
        this.clientConfigJson = '';
      });
    }, error => {
      this._alertify.error(error);
      this.clientConfigJson = '';
    });
  }

  private notifyAction(id: any, action: ActionType, key: string, value: any) {

    this._shareData.notifyCurrentDataSource(new DataSource(id, action, key, value));

  }

  private updateRowData(data) {

    if (data && data.action == ActionType.Added && data.key == "emailtemplate") {
      if (this.emailConfigs) {
        let found = this.emailConfigs.find(itm => itm.id === data.value.emailConfigId);
        if (found) {
          found.templates++;
        }  
      }
    }


    if (!data || !data.value || !data.value.APIKey || !this.currentApiKey)
      return;  

    if (data.value.APIKey === this.currentApiKey) {  

      if (data.action === ActionType.Updated) {
        let found = this.emailConfigs.find(itm => itm.id === data.id);

        if (found) {
          found.fromEmail = data.value.FromEmail;
          found.smtpServer = data.value.smtpServer;
          found.port = data.value.Port;
        }  
      }

      if (data.action == ActionType.Added) {

        if (!this.emailConfigs)
          this.emailConfigs = new Array<any>();

        this.emailConfigs.push({
          "id": data.id,
          "fromEmail": data.value.FromEmail,
          "smtpServer": data.value.smtpServer,
          "port": data.value.Port,
          "templates": 0
        });
      }

    }
  }

}
